import {ContainerModule} from '@yosmanyga/di';

import {
    AuthenticationAsGuestApi,
    AuthenticationWithFacebookApi,
    AxiosInstance,
    DeviceApi,
    FeedbackApi,
    HelpApi,
    MapApi,
    NotesApi,
    PaymentApi,
    PlayApi,
    ProfileApi,
    RestorationApi,
    TranslatorResourceLoader,
} from './';
import {AbstractTranslatorResourceLoader} from '@yosmanyga/base';
import {
    AuthenticationFrontendAsGuestAbstractApi,
    AuthenticationFrontendWithFacebookAbstractApi
} from "@yosmanyga/authentication-frontend";

const DI = new ContainerModule((bind) => {
    bind(AuthenticationFrontendAsGuestAbstractApi).to(AuthenticationAsGuestApi).inSingletonScope();
    bind(AuthenticationFrontendWithFacebookAbstractApi).to(AuthenticationWithFacebookApi).inSingletonScope();
    bind(AxiosInstance).toSelf().inSingletonScope();
    bind(DeviceApi).toSelf().inSingletonScope();
    bind(FeedbackApi).toSelf().inSingletonScope();
    bind(HelpApi).toSelf().inSingletonScope();
    bind(MapApi).toSelf().inSingletonScope();
    bind(NotesApi).toSelf().inSingletonScope();
    bind(PaymentApi).toSelf().inSingletonScope();
    bind(PlayApi).toSelf().inSingletonScope();
    bind(ProfileApi).toSelf().inSingletonScope();
    bind(RestorationApi).toSelf().inSingletonScope();
    bind(AbstractTranslatorResourceLoader)
        .to(TranslatorResourceLoader)
        .inSingletonScope();
});

export {DI};
